import { Controller } from "@hotwired/stimulus";

// Single-select choice step for the onboarding flow. Highlights the picked
// option, enables Continue, persists the selection, and advances to the next
// step (carrying the selection as a query param).
//
// Values:
//   next-url   : path to advance to on Continue (the selection is appended as
//                ?<param-name>=<value>). If blank, Continue just persists.
//   param-name : query-param name for this step's answer (default "value").
//   store-key  : sessionStorage key to persist the answer under.
export default class extends Controller {
  static targets = ["option", "continue"];
  static values = {
    nextUrl: String,
    paramName: { type: String, default: "value" },
    storeKey: String,
  };

  connect() {
    this.selectedValue = null;
  }

  select(event) {
    const button = event.currentTarget;

    this.optionTargets.forEach((opt) => {
      const isSelected = opt === button;
      opt.classList.toggle("is-selected", isSelected);
      opt.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    this.selectedValue = button.dataset.value;

    if (this.hasContinueTarget) {
      this.continueTarget.disabled = false;
    }
  }

  continue() {
    if (!this.selectedValue) return;

    if (this.storeKeyValue) {
      try {
        sessionStorage.setItem(this.storeKeyValue, this.selectedValue);
      } catch (_e) {
        // sessionStorage may be unavailable (private mode); navigation still works.
      }
    }

    if (this.nextUrlValue) {
      const url = new URL(this.nextUrlValue, window.location.origin);
      // Carry forward the current step's query params (e.g. `model`) so earlier
      // answers survive the hop, then add this step's selection.
      new URLSearchParams(window.location.search).forEach((value, key) => {
        url.searchParams.set(key, value);
      });
      url.searchParams.set(this.paramNameValue, this.selectedValue);
      window.location.assign(url.toString());
    }
  }
}
